<template>
  <el-submenu
    v-if="hasPermission('feature_group:stores')"
    class="side-navigator__submenu"
    index="stores">
    <template slot="title">
      Stores
    </template>
    <el-menu-item
      class="side-navigator__menu-item"
      index="/hotspots">
      Hotspots
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stores:stores')"
      class="side-navigator__menu-item"
      index="/stores">
      Stores
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:retailers') &&
      !hasPermission('role:retailer')"
      class="side-navigator__menu-item"
      index="/retailers">
      Retailers
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stores:wholesalers')"
      class="side-navigator__menu-item"
      index="/wholesalers">
      Wholesalers
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('role:stockcheck_admin')"
      index="/pricing/stores"
      class="side-navigator__menu-item">
      Store Search
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'StoresNavigationGroup',
  components: {
    NavigationIcon,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/StoresNavigationGroup.vue